import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (ids) {
  const { data, exec, isRequestSuccessed } = useRequest({
    name: 'GET_PRODUCTION_INFERIOR',
    url: '',
  });

  useEffect(() => {
    if (ids) {
      let url = `/api/production/inferior?production_order_ids=${ids}`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids]);

  return [data || [], isRequestSuccessed];
});
